import { components } from 'react-select'
import React from 'react'
import { SpriteIcon } from '@components/Sprites/SpriteIcon'

export const DropdownIndicator = (props) => (
    components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
            <SpriteIcon
                width={24}
                height={24}
                name={'arrow_down_small'}
            />
        </components.DropdownIndicator>
    )
)
